import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}

    :host {
        display: block;
    }

    .header {
        justify-content: space-between;
        align-items: center;
    }

    ds-filter-editor {
        height: 100%;
    }

    ds-fixed-panel {
        height: 100%;
    }

    ds-place-list-editor {
        height: 100%;
    }

    .body.open {
        height: 100%;
    }

    ds-fixed-panel::part(body) {
        height: 100%;
    }

    ds-place-list-editor::part(body) {
        padding: 0em;
        box-shadow: none;
    }
`;
